<template>
  <div id="modele">
    <router-link to="/horaires/modeles">
      <img class="imgicon" src="img/back.png" />
    </router-link>
    <div v-if="template">
      <h2>
        {{template.nom}}
        <small>
          <button class="btn">
            <font-awesome-icon :icon="'pen'" title="Renommer" @click="rename" />
          </button>
        </small>
      </h2>
      <h4>
        <font-awesome-icon :icon="'city'" />
        &nbsp;{{sitesById[template.id_site].nom}}
      </h4>

      <button class="mb-3 mt-3 btn btn-success btn-sm" @click="save()">
        <font-awesome-icon :icon="'check'" />&nbsp;Sauvegarder les modifications
      </button>
      <a href="javascript:" class="ml-3" @click="generatePDF()">
        <img class="imgicon" src="img/pdf.png" /> Télécharger en PDF
      </a>
      <br />
      <div>
        <b-button v-b-toggle="'tools'" variant="outline-primary" class="m-1  btn-sm">
          <font-awesome-icon :icon="'bolt'" />&nbsp;Actions avancées
        </b-button>
        <b-collapse id="tools">
          <div class="card">
            <div class="card-header">
              <p>Copier une semaine</p>
            </div>
            <div class="card-body">
              <div class="form-inline">
                <label>Copier la semaine&nbsp;</label>
                <select class="custom-select" v-model="semainea">
                  <option :value="undefined">-</option>
                  <option
                    v-for="semaine of template.semaines"
                    :key="semaine.multiple"
                    :value="semaine.id"
                  >Semaine {{semaine.multiple}}</option>
                </select>
                <label>&nbsp;sur la semaine&nbsp;</label>
                <select class="custom-select" v-model="semaineb">
                  <option :value="undefined">-</option>
                  <option
                    v-for="semaine of template.semaines"
                    :key="semaine.multiple"
                    :value="semaine.id"
                  >Semaine {{semaine.multiple}}</option>
                </select>
                <button class="btn btn-primary ml-3 btn-sm" @click="copy">Copier</button>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header">
              <p>Remplacer un employé</p>
            </div>
            <div class="card-body">
              <div class="form-inline">
                <label>Remplacer&nbsp;</label>
                <select class="custom-select" v-model="employea">
                  <option :value="undefined">-</option>
                  <option
                    v-for="employe of employes"
                    :key="employe.id"
                    :value="employe.id"
                  >{{employe.acronyme}} - {{employe.nom}} {{employe.prenom}}</option>
                </select>
                <label>&nbsp;par&nbsp;</label>
                <select class="custom-select" v-model="employeb">
                  <option :value="undefined">-</option>
                  <option
                    v-for="employe of employes"
                    :key="employe.id"
                    :value="employe.id"
                  >{{employe.acronyme}} - {{employe.nom}} {{employe.prenom}}</option>
                </select>
              </div>
              <div class="form-inline mt-3">
                <label>Pour la semaine&nbsp;</label>
                <select class="custom-select" v-model="employec">
                  <option :value="undefined">Toute les semaines</option>
                  <option
                    v-for="semaine of template.semaines"
                    :key="semaine.multiple"
                    :value="semaine.id"
                  >Semaine {{semaine.multiple}}</option>
                </select>
                <label>&nbsp;Pour la fonction&nbsp;</label>
                <select class="custom-select" v-model="employed">
                  <option :value="undefined">Toute les fonctions</option>
                  <option
                    v-for="fonction of fonctions"
                    :key="fonction.id"
                    :value="fonction.id"
                  >{{fonction.nom}}</option>
                </select>
                <button class="btn btn-primary ml-3 btn-sm" @click="replace">Remplacer</button>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>

      <b-card style="padding: 0px">
        <b-tabs card>
          <b-tab
            no-body
            v-for="semaine of template.semaines"
            :key="semaine.multiple"
            :title="`Semaines ${semaine.multiple}`"
          >
            <div v-for="(modele, index) of semaine.modeles" :key="index">
              <h4>{{fonctionsById[modele.id_fonction].nom}}</h4>
              <div class="table-responsive">
                <table :class="`table`">
                  <thead>
                    <tr>
                      <th width="9%">H</th>
                      <th scope="col" width="13%">Lundi</th>
                      <th scope="col" width="13%">Mardi</th>
                      <th scope="col" width="13%">Mercredi</th>
                      <th scope="col" width="13%">Jeudi</th>
                      <th scope="col" width="13%">Vendredi</th>
                      <th scope="col" width="13%">Samedi</th>
                      <th scope="col" width="13%">Dimanche</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template-row
                      :employes="employes"
                      :employesById="employesById"
                      :modele="modele"
                      heure="h10"
                      displayName="10H"
                      v-if="modele.id_fonction < 4"
                    />
                    <template-row
                      :employes="employes"
                      :employesById="employesById"
                      :modele="modele"
                      heure="h14"
                      displayName="14H"
                      v-if="modele.id_fonction < 4"
                    />
                    <template-row
                      :employes="employes"
                      :employesById="employesById"
                      :modele="modele"
                      heure="h18"
                      displayName="18H"
                      v-if="modele.id_fonction < 4"
                    />
                    <template-row
                      :employes="employes"
                      :employesById="employesById"
                      :modele="modele"
                      heure="h20"
                      displayName="20H"
                      v-if="modele.id_fonction < 4"
                    />
                    <template-row
                      :employes="employes"
                      :employesById="employesById"
                      :modele="modele"
                      heure="matin"
                      displayName="Matin"
                      v-if="modele.id_fonction >= 4"
                    />
                    <template-row
                      :employes="employes"
                      :employesById="employesById"
                      :modele="modele"
                      heure="apresmidi"
                      displayName="Après-midi"
                      v-if="modele.id_fonction === 5"
                    />
                  </tbody>
                </table>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
    <div v-else>
      <h1>Le template demandé n'existe pas</h1>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import Swal from "sweetalert2";
import { VueContext } from "vue-context";
import TemplateRow from "../components/TemplateRow";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000
});

export default {
  data() {
    return {
      sitesById: [],
      fonctions: [],
      fonctionsById: [],
      employes: [],
      employesById: [],
      template: {},
      semainea: undefined,
      semaineb: undefined,
      employea: undefined,
      employeb: undefined,
      employec: undefined
    };
  },
  components: {
    VueContext,
    TemplateRow
  },
  async created() {
    this.$store.commit("setLoading", true);
    let sites = (await api.getSites()).data.sites;
    for (let site of sites) {
      this.sitesById[site.id] = site;
    }
    this.fonctions = (await api.getFonctions()).data.fonctions;
    for (let fonction of this.fonctions) {
      this.fonctionsById[fonction.id] = fonction;
    }
    this.employes = (await api.getEmployes()).data.employes;
    for (let employe of this.employes) {
      this.employesById[employe.id] = employe;
    }
    this.template = (
      await api.getTemplateById(this.$route.params.id)
    ).data.template;
    this.prepareTemplate();
    this.$store.commit("setLoading", false);
  },
  methods: {
    prepareTemplate() {
      for (let semaine of this.template.semaines) {
          for (let modele of semaine.modeles) {
            for (let jour of modele.jours) {
              jour = this.prepareDay(jour, "h10");
              jour = this.prepareDay(jour, "h14");
              jour = this.prepareDay(jour, "h18");
              jour = this.prepareDay(jour, "h20");
              jour = this.prepareDay(jour, "matin");
              jour = this.prepareDay(jour, "apresmidi");
            }
          }
        }
    },
    prepareDay(jour, heure) {
      const SIB_NO_QSP = 1;
      const NO_SIB_QSP = 2;
      const SIB_QSP = 3;
      if (jour[`${heure}s`] == SIB_NO_QSP) {
        jour[`${heure}s`] = true;
      } else if (jour[`${heure}s`] == NO_SIB_QSP) {
        jour[`${heure}s`] = false;
        jour[`${heure}`] = -1;
      } else if (jour[`${heure}s`] == SIB_QSP) {
        jour[`${heure}s`] = true;
        jour[`${heure}`] = -1;
      }
      return jour;
    },
    generatePDF() {
      api.pdf(`modele`, { id: this.template.id }, `modele`);
    },
    async save() {
      let response = await api.saveTemplate(this.template);
      Toast.fire({
        type: response.code === 200 ? "success" : "error",
        text: response.message
      });
    },
    copy() {
      let a = undefined;
      for (let semaine of this.template.semaines) {
        if (semaine.id === this.semainea) {
          a = semaine;
          break;
        }
      }
      let b = undefined;
      for (let semaine of this.template.semaines) {
        if (semaine.id === this.semaineb) {
          b = semaine;
          break;
        }
      }
      if (a && b) {
        for (let i = 0; i < a.modeles.length; i++) {
          for (let index = 0; index < a.modeles[i].jours.length; index++) {
            b.modeles[i].jours[index].h10 = a.modeles[i].jours[index].h10;
            b.modeles[i].jours[index].h14 = a.modeles[i].jours[index].h14;
            b.modeles[i].jours[index].h18 = a.modeles[i].jours[index].h18;
            b.modeles[i].jours[index].h20 = a.modeles[i].jours[index].h20;
            b.modeles[i].jours[index].matin = a.modeles[i].jours[index].matin;
            b.modeles[i].jours[index].apresmidi =
              a.modeles[i].jours[index].apresmidi;
            b.modeles[i].jours[index].h10s = a.modeles[i].jours[index].h10s;
            b.modeles[i].jours[index].h14s = a.modeles[i].jours[index].h14s;
            b.modeles[i].jours[index].h18s = a.modeles[i].jours[index].h18s;
            b.modeles[i].jours[index].h20s = a.modeles[i].jours[index].h20s;
            b.modeles[i].jours[index].matins = a.modeles[i].jours[index].matins;
            b.modeles[i].jours[index].apresmidis = a.modeles[i].jours[index].apresmidis;
          }
        }
        Toast.fire({
          type: "success",
          text: "La copie a été effectuée"
        });
      }
      this.semainea = undefined;
      this.semaineb = undefined;
    },
    replace() {
      if (this.employea && this.employeb) {
        let semaines = [];
        if (this.employec) {
          //employec ==> semaine
          for (let semaine of this.template.semaines) {
            if (semaine.id === this.employec) {
              semaines.push(semaine);
              break;
            }
          }
        } else {
          //Toutes les semaines
          semaines = this.template.semaines;
        }
        for (let semaine of semaines) {
          for (let modele of semaine.modeles) {
            for (let jour of modele.jours) {
              // fonction
              if (
                !this.employed ||
                (this.employed && modele.id_fonction === this.employed)
              ) {
                if (jour.h10 === this.employea) jour.h10 = this.employeb;
                if (jour.h14 === this.employea) jour.h14 = this.employeb;
                if (jour.h18 === this.employea) jour.h18 = this.employeb;
                if (jour.h20 === this.employea) jour.h20 = this.employeb;
                if (jour.matin === this.employea) jour.matin = this.employeb;
                if (jour.apresmidi === this.employea)
                  jour.apresmidi = this.employeb;
              }
            }
          }
        }
        Swal.fire({
          type: "success",
          text: "Remplacement effectué."
        });
      }
    },
    rename() {
      Swal.fire({
        title: "Renommer le modèle",
        input: "text",
        inputValue: this.template.nom,
        showCancelButton: true,
        confirmButtonText: "Renommer",
        cancelButtonText: "Annuler",
        showLoaderOnConfirm: true
      }).then(async result => {
        if (result.value) {
          let response = await api.renameTemplate(
            this.template.id,
            result.value
          );
          if (response.code === 200) {
            this.template.nom = result.value;
          } else {
            Swal.fire({
              type: "error",
              message: response.message
            });
          }
        }
      });
    }
  }
};
</script>